import { Localization } from '../crystallize/types';
import { LanguageCountryList } from '../crystallize/types/localization';

export const fallbackLanguage = 'en';
export const fallbackCountry = '001';

export const DEFAULT_LOCALIZATION: Localization = {
  language: fallbackLanguage,
  country: fallbackCountry,
}; // default localization fallback values
// legacy phoenix shop languages
export const legacyLanguages = ['en', 'de', 'fr', 'it', 'es', 'nl'];
export const languages = ['en', 'de', 'fr', 'it', 'es', 'nl'];

export const countryLanguagesLimitations = {
  us: ['en'],
};
export const rootPathCountryLanguageLimitations = {
  webhierarchyhermes: ['us'],
};

// Fallback for all crystallize countries and languages
export const fallbackLanguageCountryList: LanguageCountryList = {
  countries: [
    { code: 'al' },
    { code: 'ad' },
    { code: 'at' },
    { code: 'be' },
    { code: 'ba' },
    { code: 'bg' },
    { code: 'ca' },
    { code: 'de' },
    { code: 'hr' },
    { code: 'cy' },
    { code: 'cz' },
    { code: 'dk' },
    { code: 'eg' },
    { code: 'ee' },
    { code: 'fi' },
    { code: 'fr' },
    { code: 'gr' },
    { code: 'ie' },
    { code: 'it' },
    { code: 'lv' },
    { code: 'li' },
    { code: 'lt' },
    { code: 'lu' },
    { code: 'mt' },
    { code: 'mc' },
    { code: 'me' },
    { code: 'nl' },
    { code: 'mk' },
    { code: 'no' },
    { code: 'pl' },
    { code: 'pt' },
    { code: 'ro' },
    { code: 'sm' },
    { code: 'sa' },
    { code: 'rs' },
    { code: 'sk' },
    { code: 'si' },
    {
      code: 'es',
      areas: [
        {
          code: 'pe',
          name: 'Spain',
          includedZipCodes: [],
          excludedZipCodes: ['35*', '38*'],
          isDefault: true,
        },
        {
          code: 'ci',
          name: 'Spain - Canary islands',
          includedZipCodes: ['35*', '38*'],
          excludedZipCodes: [],
          isDefault: true,
        },
      ],
    },
    { code: 'se' },
    { code: 'ch' },
    { code: 'tr' },
    { code: 'uk' },
    { code: 'ae' },
    { code: 'us' },
  ],
  languages: [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'German' },
    { code: 'fr', name: 'French' },
    { code: 'es', name: 'Spanish' },
    { code: 'it', name: 'Italian' },
    { code: 'nl', name: 'Dutch' },
  ],
};
